/*
  File: assets/ozplug-hero-one.js
  Purpose: Android-specific hero rendering fix. Content visibility must never depend on this file.
*/
(function () {
  'use strict';

  if (window.OZPlugHeroOneReady) return;
  window.OZPlugHeroOneReady = true;

  var SECTION_SELECTOR = '[data-oz-hero-one]';
  var MOBILE_QUERY = '(max-width: 767px)';
  var androidMobileMedia = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
  var resizeTimer = null;

  function isAndroidMobile() {
    return /Android/i.test(navigator.userAgent || '') && (androidMobileMedia ? androidMobileMedia.matches : window.innerWidth <= 767);
  }

  function applyAndroidHeroFix(root) {
    if (!root || !isAndroidMobile()) return;

    document.documentElement.classList.add('ozplug-android-mobile');

    var heading = root.querySelector('.oz-hero-one__heading');
    var lead = root.querySelector('.oz-hero-one__lead');
    var buttons = root.querySelector('.oz-hero-one__buttons');
    var btns = root.querySelectorAll('.oz-hero-one__btn');
    var legal = root.querySelector('.oz-hero-one__legal');
    var legalItems = root.querySelectorAll('.oz-hero-one__legal-item');
    var visual = root.querySelector('.oz-hero-one__visual');
    var grid = root.querySelector('.oz-hero-one__grid');
    var wrap = root.querySelector('.oz-hero-one__wrap');

    /*
      Inline styles are intentional for the Android-only text/layout fix.
      They are never used to hide or delay real content.
    */
    root.style.setProperty('padding-top', '34px', 'important');
    root.style.setProperty('padding-right', '20px', 'important');
    root.style.setProperty('padding-bottom', '42px', 'important');
    root.style.setProperty('padding-left', '20px', 'important');
    root.style.setProperty('-webkit-text-size-adjust', '100%', 'important');
    root.style.setProperty('text-size-adjust', '100%', 'important');

    if (wrap) {
      wrap.style.setProperty('width', '100%', 'important');
      wrap.style.setProperty('max-width', '100%', 'important');
    }

    if (grid) {
      grid.style.setProperty('display', 'grid', 'important');
      grid.style.setProperty('grid-template-columns', 'minmax(0, 1fr)', 'important');
      grid.style.setProperty('gap', '30px', 'important');
      grid.style.setProperty('align-items', 'start', 'important');
    }

    if (heading) {
      var narrow = window.innerWidth <= 390;
      heading.style.setProperty('display', 'block', 'important');
      heading.style.setProperty('width', '100%', 'important');
      heading.style.setProperty('max-width', narrow ? '286px' : '300px', 'important');
      heading.style.setProperty('margin', '0 0 18px', 'important');
      heading.style.setProperty('font-family', '"Bebas Neue", Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif', 'important');
      heading.style.setProperty('font-size', narrow ? '42px' : '44px', 'important');
      heading.style.setProperty('font-weight', '400', 'important');
      heading.style.setProperty('line-height', '.94', 'important');
      heading.style.setProperty('letter-spacing', '.3px', 'important');
      heading.style.setProperty('white-space', 'normal', 'important');
      heading.style.setProperty('text-transform', 'uppercase', 'important');
      heading.style.setProperty('-webkit-text-size-adjust', '100%', 'important');
      heading.style.setProperty('text-size-adjust', '100%', 'important');

      var em = heading.querySelector('em');
      if (em) {
        em.style.setProperty('display', 'block', 'important');
        em.style.setProperty('font-family', 'inherit', 'important');
        em.style.setProperty('font-size', 'inherit', 'important');
        em.style.setProperty('font-weight', 'inherit', 'important');
        em.style.setProperty('line-height', 'inherit', 'important');
        em.style.setProperty('letter-spacing', 'inherit', 'important');
      }
    }

    if (lead) {
      lead.style.setProperty('max-width', '350px', 'important');
      lead.style.setProperty('margin', '0 0 28px', 'important');
      lead.style.setProperty('font-size', window.innerWidth <= 390 ? '15.8px' : '16px', 'important');
      lead.style.setProperty('line-height', '1.55', 'important');
    }

    if (buttons) {
      buttons.style.setProperty('display', 'grid', 'important');
      buttons.style.setProperty('grid-template-columns', '1fr', 'important');
      buttons.style.setProperty('gap', '14px', 'important');
      buttons.style.setProperty('width', '100%', 'important');
      buttons.style.setProperty('margin', '0 0 32px', 'important');
    }

    btns.forEach(function (btn) {
      btn.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('min-height', '54px', 'important');
      btn.style.setProperty('padding', '0 18px', 'important');
      btn.style.setProperty('border-radius', '999px', 'important');
      btn.style.setProperty('font-size', '16px', 'important');
      btn.style.setProperty('font-weight', '800', 'important');
      btn.style.setProperty('line-height', '1.1', 'important');
    });

    if (legal) {
      legal.style.setProperty('display', 'grid', 'important');
      legal.style.setProperty('grid-template-columns', '1fr', 'important');
      legal.style.setProperty('gap', '15px', 'important');
      legal.style.setProperty('padding-top', '26px', 'important');
    }

    legalItems.forEach(function (item) {
      item.style.setProperty('width', '100%', 'important');
      item.style.setProperty('font-size', '13px', 'important');
      item.style.setProperty('line-height', '1.35', 'important');
    });

    if (visual) {
      visual.style.setProperty('width', '100%', 'important');
      visual.style.setProperty('max-width', '100%', 'important');
      visual.style.setProperty('min-height', '250px', 'important');
      visual.style.setProperty('margin', '4px auto 0', 'important');
      visual.style.setProperty('padding', '22px', 'important');
      visual.style.setProperty('border-radius', '20px', 'important');
    }
  }

  function init(root) {
    if (!root || root.dataset.ozHeroReady === 'true') return;
    root.dataset.ozHeroReady = 'true';
    applyAndroidHeroFix(root);
  }

  function initAll(context) {
    (context || document).querySelectorAll(SECTION_SELECTOR).forEach(init);
  }

  function refreshAll() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll(SECTION_SELECTOR).forEach(applyAndroidHeroFix);
    }, 120);
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () { initAll(document); });

  window.addEventListener('resize', refreshAll, { passive: true });
  window.addEventListener('orientationchange', refreshAll, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    refreshAll();
  });
})();
